/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_File_IconInputs */

const en_enum_custom_page_icon_file_icon = /** @type {(inputs: Enum_Custom_Page_Icon_File_IconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Icon File Icon`)
};

const de_enum_custom_page_icon_file_icon = /** @type {(inputs: Enum_Custom_Page_Icon_File_IconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Icon File Icon`)
};

/**
* | output |
* | --- |
* | "Icon File Icon" |
*
* @param {Enum_Custom_Page_Icon_File_IconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_file_icon = /** @type {((inputs?: Enum_Custom_Page_Icon_File_IconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_File_IconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_file_icon(inputs)
	return de_enum_custom_page_icon_file_icon(inputs)
});